<template>
  <div class="pages">
    <div class="loadding" v-if="!page_show">
      <van-loading color="#00428e" type="spinner" size="48" />
    </div>
    <div v-else>
      <img class="top_img" :src="Util.getImgUrl(images.top)" />
      <img class="logo_img2" :src="Util.getImgUrl(images.logo)" />
      <img class="left_img" :src="Util.getImgUrl(images.left)" />
      <img class="right_img" :src="Util.getImgUrl(images.right)" />
      <img class="type_img" :src="Util.getImgUrl(images.type_recommends)" />
      <div class="content_box">
        <div v-if="list.length">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadData">
              <div class="employ_box" v-for="item in  list " :key="item.position_id"
                @click="onClickDetail(item.position_id)">
                <div class="employ_top_box" :style="{ backgroundImage: 'url(' + Util.getImgUrl(images.spec) + ')' }">
                  <div class="position_name">{{ item.position_name }}</div>
                </div>
                <div class="label_list">
                  <div class="label">{{ item.area }}</div>
                  <div class="label">{{ item.position_type }}</div>
                  <div class="label">{{ item.people_num_text }}</div>
                </div>
                <div class="info_box">
                  <div class="info_left">申请时间</div>
                  <div class="info_right">{{ item.created_at }}</div>
                </div>
                <div class="info_box">
                  <div class="info_left">姓名</div>
                  <div class="info_right">{{ item.realname }}</div>
                </div>
                <div class="info_box">
                  <div class="info_left">手机</div>
                  <div class="info_right">{{ item.mobile }}</div>
                </div>
                <div class="info_box">
                  <div class="info_left">邮箱</div>
                  <div class="info_right">{{ item.email }}</div>
                </div>
                <div class="uploads_box">
                  <div>附件</div>
                  <div class="upload_files">
                    <div class="file_box" v-for="file in item.upload_files" :key="file.file_id"
                      @click="onOpenFile(file.url)">
                      <van-icon :name="Util.getImgUrl(file.icon)" size="24px" />
                      <div class="original_name">{{ file.original_name }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
        <div v-else-if="list.length <= 0 && page_show">
          <van-empty :image="Util.getImgUrl(empty_msg.image)"
            :description="empty_msg && empty_msg.title ? empty_msg.title : '描述文字'" />
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page_show: false,
      popup_show: false,
      nav_show: false,
      page: 1,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      empty_msg: null,
      images: null,
    }
  },
  mounted() {
    document.title = '中船航海人才招聘'
    setTimeout(() => {
      this.loadData()
    }, 500)
  },
  methods: {
    loadData() {
      let that = this
      that.$api.employMineRecommends({
        page: that.page,
      }).then(res => {
        that.Util.wechatShare(res.data.share)
        if (that.page == 1) {
          that.list = []
          that.images = res.data.images
        }
        that.list = that.list.concat(res.data.records.data)
        that.loading = false
        that.refreshing = false
        if (!res.data.records.next_page_url) {
          that.finished = true
        } else {
          that.page += 1
        }
        that.empty_msg = res.data.empty_msg
        that.page_show = true
      })
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.page = 1
      this.loadData();
    },
    onOpenFile(url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style scoped src="./employ.css"></style>
<style scoped src="./mineRecommends.css"></style>
    